import type { GroupField } from '@components/pages/FormBuilder/types'

export enum FormTemplateStatus {
  Draft = 'draft',
  Pending = 'pending',
  Approved = 'approved',
}

export interface IFormTemplate {
  form_template_id?: string
  template_key?: string
  version?: number
  title: string
  category_title: string
  status: FormTemplateStatus
  schema_json: string | GroupField[] | { groups: GroupField[] }
  created_by?: string
  updated_by?: string
  approved_by?: string | null
}

export interface ListFormTemplatesParams {
  category?: string
  status?: string
  q?: string
  limit?: number
  offset?: number
}

export interface FormGroupItem {
  templateKey: string
  formTemplateId: string | null
  title: string | null
  version: number | null
  sortOrder: number
  available: boolean
}

export interface FormGroup {
  id: string
  name: string
  description: string | null
  isNewPatientKioskDefault: boolean
  items: FormGroupItem[]
}

export interface FormGroupInput {
  name: string
  description?: string | null
  templateKeys: string[]
}

export type { GroupField }
